import { render, staticRenderFns } from "./ElementList.vue?vue&type=template&id=6bf99211&scoped=true&"
import script from "./ElementList.vue?vue&type=script&lang=ts&"
export * from "./ElementList.vue?vue&type=script&lang=ts&"
import style0 from "./ElementList.vue?vue&type=style&index=0&id=6bf99211&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf99211",
  null
  
)

export default component.exports